// extracted by mini-css-extract-plugin
export default {"backdrop":"Loading_backdrop__PCuok","modal":"Loading_modal__pLmms","loader":"Loading_loader__4Gy8I","load6":"Loading_load6__ElLco","round":"Loading_round__5bAg9"};